<template>
	<v-expansion-panel>
		<v-expansion-panel-header>
			<slot name="header" :question="question"
				><div class="accordion-toggle question-toggle">{{ question }}</div>
			</slot>
		</v-expansion-panel-header>
		<v-expansion-panel-content>
			<slot name="answer" :answer="answer">
				<div v-html="$sanitize(answer)" class="answer"></div>
			</slot>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>
import SanitizeMixin from '../../../mixins/buyout/sanitize';
export default {
	name: 'FaqItem',
	mixins: [SanitizeMixin],
	props: {
		question: {
			type: String,
			require: true
		},
		answer: {
			type: String,
			require: true
		}
	}
}
</script>
